'use client'
import React, { useState } from 'react';

export default function Avatar({ 
  src, 
  alt, 
  name, 
  size = 'md', 
  className = '',
  getInitials 
}) {
  const [imageError, setImageError] = useState(false);
  
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl'
  };

  const sizePx = {
    sm: 32,
    md: 40,
    lg: 48,
    xl: 64,
  };

  const handleImageError = () => {
    setImageError(true);
  };

  // If image failed to load or no src provided, show initials
  if (imageError || !src) {
    return (
      <div className={`bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center text-white font-bold ${sizeClasses[size]} ${className}`}>
        {getInitials ? getInitials(name) : (name ? name.charAt(0).toUpperCase() : 'U')}
      </div>
    );
  }

  const px = sizePx[size] ?? 40;

  // Show image with error handling
  return (
    <img
      src={src}
      alt={alt || name}
      width={px}
      height={px}
      onError={handleImageError}
      className={`rounded-full object-cover ${sizeClasses[size]} ${className}`}
    />
  );
} 